<template>
  <div>
    <Divider dashed style="color:#fff">设置填充内容</Divider>
    <div>
      <h4 class="workplatform-title m-t-10 m-b-20">作业日期</h4>
      <DatePicker
        placeholder="选择作业日期"
        v-model="actionDate"
        type="date"
        style="width:100%"
        :editable="false"
        :clearable="false"
        @on-change="changeActionDate"
      ></DatePicker>
    </div>
    <set-screen
      :agreeFileArray="fileArray"
      :selectedResourceIds="selectedResourceIdArray"
      :curTaskId="curTaskId"
      :selectedTaskitemIds="selectedTaskitemIdArray"
      :setOperatingType="2"
      :fileCreateDate="fileDate"
      :btnSetLoading.sync="btnSetLoading"
      @parentMethod="handelSubmit"
    >
      <template #pictureDate>
        <div class="m-b-10">
          <label>素材类型：</label>
          <RadioGroup
            v-model="materialType"
            type="button"
            size="small"
            @on-change="getFileDates"
          >
            <Radio
              v-for="item in materialTypeArray"
              :key="'m_'+item.value"
              :label="item.value"
            >{{item.name}}</Radio>
          </RadioGroup>
        </div>
        <div>
          <Select
            v-model="fileDate"
            filterable
            placeholder="选择画面上传日期"
            @on-change="changeFileDate"
          >
            <Option
              v-for="item in fileDateArray"
              :key="'f_'+item"
              :value="item"
            >{{item}}</Option>
          </Select>
        </div>

      </template>
    </set-screen>
  </div>
</template>

<script>
import SetScreen from '@/components/task/SetScreen'
import { agreefile, getFileUploadDateList } from '@/api/msp/file'
import { updateTaskitemFile } from '@/api/msp/demandV3'
import { getFillType } from '@/api/msp/status'
export default {
  components: {
    SetScreen
  },
  data () {
    return {
      query: {
        pageNumber: 1,
        pageSize: 500,
        approvalDate: '',
        approvalId: null,
        fileTypes: 1,
        keyword: null,
        status: 5,
        createDate: '',
        type: null
      },
      fileArray: [],
      fileDateArray: [],
      fileDate: '',
      actionDate: '',
      materialType: 0,
      materialTypeArray: [
        { value: 0, name: '全部' }
      ],
      dateQuery: {
        type: null,
        startDate: '',
        endDate: ''
      },
      btnSetLoading: false
    }
  },
  computed: {
    curTaskId () {
      return this.$store.state.workOrder.taskId
    },
    selectedResourceIdArray: {
      get () {
        return this.$store.state.workOrder.selectedResourceIdArray
      },
      set (val) {
        this.$store.commit('set_selected_resourceId_array', val)
      }
    },
    selectedTaskitemIdArray: {
      get () {
        return this.$store.state.workOrder.selectedTaskItemIds
      },
      set (val) {
        this.$store.commit('set_selected_task_item_ids', val)
      }
    }
  },
  created () {
    this.getScreenTypeData()
    this.getFileDates()
  },
  methods: {
    getScreenTypeData () {
      getFillType().then(res => {
        if (res && !res.errcode) {
          this.materialTypeArray = this.materialTypeArray.concat(res)
        }
      })
    },
    /**
     * 获取素材上传时间集合
     */
    getFileDates () {
      this.dateQuery.type = this.materialType === 0 ? null : this.materialType
      getFileUploadDateList(this.dateQuery).then(res => {
        if (res && !res.errcode) {
          this.fileDateArray = res
          this.fileDate = this.fileDateArray.sort()[0]
          this.getFileData()
        } else {
          this.fileDateArray = []
        }
      })
    },
    /**
     * 获取已通过审核的画面文件
     */
    getFileData () {
      this.query.type = this.materialType === 0 ? null : this.materialType
      this.query.createDate = this.fileDate || ''
      agreefile(this.query).then(res => {
        if (res && !res.errcode) {
          this.fileArray = res.list
        } else {
          this.fileArray = []
        }
      })
    },
    changeActionDate (date) {
      this.actionDate = date
    },
    handelSubmit (data) {
      if (!this.actionDate) {
        this.$Notice.error({ desc: '请选择作业日期' })
        return false
      }
      this.btnSetLoading = true
      if (data && data instanceof Object) {
        // data.taskId = this.curTaskId
        // data.demandMainId = this.curTaskId
        data.actionDate = this.actionDate

        updateTaskitemFile(data).then(res => {
          this.btnSetLoading = false
          if (res && res.errcode === 0) {
            this.selectedResourceIdArray = []
            this.selectedTaskitemIdArray = []
            this.$store.commit('set_temp_selected_item', null)
            this.$store.dispatch('getTaskItemData')
            this.$Notice.success({ desc: '操作成功' })
          }
        })
      } else {
        this.$Notice.error({ desc: '非法请求' })
      }
    },
    changeFileDate () {
      this.getFileData()
    }
  }
}
</script>
